export const primitiveScenePlanSource = {
    episodeHandle: 'EPISODE-primitive-natural-add', sceneId: 'simple',
} as const;

export const primitiveScenePlanGuidance = {
    teachingNotes: ['Explain concatenation when alignment STARTS, and the result when merging COMPLETES.'],
} as const;
